import { useStatusBarStore } from "../stores/statusBarStore";

export const useStatusBar = () => {
  const { actions } = useStatusBarStore();

  return {
    // Quick status setters
    success: (message: string) => actions.setSuccess(message),
    warning: (message: string) => actions.setWarning(message),
    error: (message: string) => actions.setError(message),
    info: (message: string) => actions.setInfo(message),
    loading: (message: string) => actions.setLoading(message),

    // Custom status
    custom: (
      message: string,
      type: "success" | "warning" | "error" | "info" | "loading",
      icon?: string
    ) => actions.setCustom(message, type, icon),

    // Visibility control
    hide: () => actions.hide(),
    show: () => actions.show(),

    // Reset to default
    reset: () => actions.reset(),

    // Async operations with loading states
    withLoading: async <T>(
      loadingMessage: string,
      operation: () => Promise<T>,
      successMessage?: string,
      errorMessage?: string
    ): Promise<T> => {
      try {
        actions.setLoading(loadingMessage);
        const result = await operation();

        if (successMessage) {
          actions.setSuccess(successMessage);
        } else {
          actions.setSuccess("Operation completed successfully");
        }

        return result;
      } catch (error) {
        const errorMsg =
          errorMessage ||
          `Operation failed: ${
            error instanceof Error ? error.message : "Unknown error"
          }`;
        actions.setError(errorMsg);
        throw error;
      }
    },
  };
};
